
import React from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import moment from 'moment'

import metadata from './MLClaimDetailsDetailedSummary.metadata.json5';
import './MLClaimDetailsDetailedSummary.messages';

function MLClaimDetailsDetailedSummary(props) {
    const {
        claim
    } = props;

    const formatDate = (date) => {
        return date ? moment(date).format('MM/DD/YYYY') : '';
    }

    const formatTime = (date) => {
        return date ? moment(date).format('h:mm a') : '';
    }

    const getLossLocationAddress = () => {
        const address = claim?.lossLocation;
        if (address) {
            return <>
                {address.addressLine1}
                <br />
                {`${address.city}, ${address.state} ${address.postalCode}`}
            </>
        }
    };

    const overrides = {
        claimNumber: {
            content: claim?.claimNumber
        },
        claimDate: {
            content: formatDate(claim?.lossDate_ext)
        },
        claimTime: {
            content: formatTime(claim?.lossDate_ext)
        },
        claimStatus: {
            content: claim?.claimState
        },
        locationCol: {
            visible: !!claim?.lossLocation
        },
        location: {
            content: getLossLocationAddress()
        },
        DescriptionCol: {
            visible: !!claim?.description
        },
        Description: {
            content: claim?.description
        }
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsDetailedSummary;
